module.exports = __webpack_public_path__ + "img/weixin.ebf3adcc.png";